import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {PAYMENT_FLOWS_QUERY_KEY} from "../queryKeys";

type DeletePaymentFlowVariables = {id: number};

const deletePaymentFlow = async ({id}: DeletePaymentFlowVariables): Promise<void> => {
  await axiosReachInstance.delete(`/payment_flows/${id}`);
};

export const useDeletePaymentFlow = (
  options?: BaseMutationOptions<void, DeletePaymentFlowVariables>
): BaseUseMutationResult<void, DeletePaymentFlowVariables> => {
  return useBaseMutation<void, DeletePaymentFlowVariables>(deletePaymentFlow, {
    ...options,
    prefixKeysToReset: () => [[PAYMENT_FLOWS_QUERY_KEY]],
  });
};
